import { Routes } from '@angular/router';
import { canActivate, redirectUnauthorizedTo } from "@angular/fire/auth-guard";
import { WebEsoluzionRoutes } from './features/web-esoluzion/web-esoluzion.routes';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./features/auth/auth.component').then((c) => c.AuthComponent)
  },
  {
    path: 'web-esoluzion',
    loadComponent: () => import('./features/web-esoluzion/web-esoluzion.component').then((c) => c.WebEsoluzionComponent),
    children: WebEsoluzionRoutes,
    ...canActivate(() => redirectUnauthorizedTo(['login'])),
  },
  { path: '', pathMatch: 'full', redirectTo: 'login' },
];
